<template>
  <div class="mt-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h5>{{ $t('surveys') }}</h5>
      <b-badge variant="secondary">{{ surveys.length }}</b-badge>
    </div>
    <div class="border rounded p-4 bg-light">
      <b-row v-if="surveys.length > 0">
        <template v-for="(surveyList, title) in groupBySurveys">
           <b-col cols="12" :key="'title-' + title"><h6 class="mt-2">{{ title }}</h6></b-col>
          <b-col
            v-for="survey in surveyList"
            :key="survey.related_id"
            cols="12"
            class="mb-4"
          >
            <b-card
              class="h-100 shadow-sm survey-card border-0"
              no-body
            >
              <b-card-body class="d-flex flex-column">
                <div class="d-flex justify-content-between mb-2">
                  <small class="text-muted">
                      <i class="ri-time-line"></i> {{ toLocaleDate(survey.start_date) }}
                  </small>
                    <small class="text-muted">
                        <i class="ri-time-line"></i> {{ toLocaleDate(survey.end_date) }}
                    </small>
                </div>

                <h6 class="card-title font-weight-bold text-primary mb-2">
<!--                  {{getLocaleText(survey,'explanation')  }}-->
                    {{getLocaleText(survey.course,'name') }}

                </h6>

<!--                <b-card-text class="text-muted small flex-grow-1">-->
<!--                </b-card-text>-->

                <div class="mt-3">
                  <b-button
                    variant="outline-primary"
                    block
                    size="sm"
                    class="w-100"
                    @click="goToSurvey(survey)"
                  >
                    {{ $t('take_the_survey') }} <i class="fa fa-arrow-right ml-1"></i>
                  </b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </template>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Surveys",
    props:{
      surveys:{
          type: Array,

      }
    },
    computed:{
      groupBySurveys (){
          const surveys =[...this.surveys]
          return this.groupBy(surveys,this.getLocaleField('name'))
      }
    },
  methods: {
    goToSurvey(item) {
      this.$router.push("/surveys/" +
          item.id +
          "/evaluate/" +
          (item.related_id ?? 0))
    }
  }
}
</script>

<style scoped>
/* Add hover effect for better interactivity */
.survey-card {
  transition: all 0.3s ease;
}

.survey-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
</style>
